// extracted by mini-css-extract-plugin
module.exports = {"wrap":"activityAnswer_wrap__vz0js","solution":"activityAnswer_solution__3WxWp","buttons":"activityAnswer_buttons__20JM5"};